import { type ClassValue, clsx } from "clsx";

/**
 * Utility function to merge Tailwind CSS classes
 * Uses clsx for class name merging
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
